export enum ValueType {
  // 固定值 1
  fixed = 1,
  // 自动数采取数 = 2
  auto = 2,
  // 能源账单获取
  energyBill = 3,
}

export const ValueTypeDisplay = {
  [ValueType.fixed]: '固定值',
  [ValueType.auto]: '自动数采取数',
  [ValueType.energyBill]: '能源账单获取',
};

export interface AutoDataSettingTypes {
  /**
   * 要求物理量单位id
   */
  requirePhysicalUnitId?: number;
  transformCoefficient?: number;
  /**
   * 用能分析组id
   */
  energyGroupId?: number;
  /**
   * 用能单元id
   */
  energyUnitIds?: number[];
  /**
   * 计量类别id
   */
  meterTypeId?: number;
  /**
   * 默认物理量单位id
   */
  defaultPhysicalUnitId?: number;
}

export interface BillSettingTypes {
  /**
   * 单位转换系数
   */
  transformCoefficient?: number;
  /**
   * 能源介质场景id
   */
  sceneId?: number;
  /**
   * 能源介质id
   */
  energyMediumId?: number;
  /**
   * 表单中的能源介质级联路径
   */
  energyMediumPath?: number[];
}
